export enum SaveLocation {
  Save_To_Cloud = 0,
  Save_Local = 1,
  Download_Blocks = 2,
  LoadBlocks=3,
  Screenshot_Blocks=4,
  Clear_Blocks=5,
  Save_Output=6,
}
